import { forwardRef, useEffect, useState } from "react"

function isLocalPath(destination) {
  return typeof destination === "string" && destination.startsWith("/") && !destination.startsWith("//")
}

export function useRouter() {
  const [path, setPath] = useState(window.location.pathname)

  useEffect(() => {
    const onPop = (event) => {
      const nextPath = window.location.pathname

      if (event.isTrusted && isLocalPath(nextPath)) {
        window.location.replace(`${nextPath}${window.location.search}${window.location.hash}`)
        return
      }

      setPath(nextPath)
    }

    window.addEventListener("popstate", onPop)
    return () => window.removeEventListener("popstate", onPop)
  }, [])

  const navigate = (to) => {
    if (to === window.location.pathname) return
    window.history.pushState({}, "", to)
    setPath(to)
  }

  return { path, navigate }
}

export const RouterLink = forwardRef(function RouterLink(
  { to, href, onClick, target, rel, children, ...props },
  ref,
) {
  const destination = to || href || "#"

  return (
    <a
      {...props}
      ref={ref}
      href={destination}
      data-turbo={isLocalPath(destination) ? "false" : undefined}
      target={target}
      rel={rel}
      onClick={(event) => {
        onClick?.(event)
        if (event.defaultPrevented) return
        if (!isLocalPath(destination)) return
        if (target && target !== "_self") return
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return

        event.preventDefault()
        if (destination === window.location.pathname) return

        window.history.pushState({}, "", destination)
        window.dispatchEvent(new PopStateEvent("popstate"))
      }}
    >
      {children}
    </a>
  )
})

export function Link(props) {
  return <RouterLink {...props} />
}
